/**
 * Role Templates API Service (TASK-274)
 *
 * Read-only client for the role/template picker. The backend
 * `GET /api/v1/role-templates/` endpoint returns the templates SELECTABLE for
 * the current user's organization, already filtered by the org's cabinet mode
 * (estimator → souffleur/operator; ecommerce → ecommerce_operator). The UI just
 * renders whatever it gets, so the dropdown is data-driven and mode-aware.
 */
import apiClient from './client';
import type { RoleTemplate } from '../../types/user';

export const roleTemplatesApi = {
  /**
   * List role templates available for the current org's mode.
   * GET /api/v1/role-templates/
   *
   * Resilient to both DRF response shapes: a bare array, or a paginated
   * object `{ count, next, previous, results: [...] }`.
   */
  list: async (): Promise<RoleTemplate[]> => {
    const response = await apiClient.get('/api/v1/role-templates/');
    const d = response.data;
    return Array.isArray(d) ? d : (d?.results ?? []);
  },
};

export default roleTemplatesApi;
